import { Typography, TypographyProps } from "@mui/material";

interface IProps extends TypographyProps {
  title: string;
}
const Heading: React.FC<IProps> = ({ title, ...props }) => {
  return (
    <Typography
      variant="h4"
      component="h2"
      fontSize={"1.5rem !important"}
      color="text.primary"
      {...props}
    >
      {title}
    </Typography>
  );
};

export default Heading;
